import React from "react";
import { Navbar } from "../Navbar";
import { useAuth } from "../../contexts/AuthContext";
import { useLocation } from "react-router-dom";

const PUBLIC_PATHS = ["/", "/change-password", "/sso/callback", "/sso/complete"];

export const Layout = ({ children }) => {
  const auth = useAuth();
  const location = useLocation();

  const isPublic = PUBLIC_PATHS.includes(location.pathname);
  const showNavbar = Boolean(auth?.user && !isPublic);

  return (
    <>
      {showNavbar && <Navbar />}
      {children}
    </>
  );
};
